import { render } from "./LeafScanIcon.vue?vue&type=template&id=55ba51d2"
import script from "./LeafScanIcon.vue?vue&type=script&lang=js"
export * from "./LeafScanIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__